module.exports = __webpack_public_path__ + "static/media/ep-logo-black.357e6f54.svg";